import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteOrganisationAdminRequestType } from '../types';

export const deleteOrganisationAdmin = async ({
  pathParams: { organisationId, userId },
}: DeleteOrganisationAdminRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/administrators/${userId}`;
  await apiAuthClient.delete<void>(url);
};
